/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { CustomerProfileDtoEdgeModel, CustomerProfileDtoEdgeModelType } from "./CustomerProfileDtoEdgeModel"
import { CustomerProfileDtoEdgeModelSelector } from "./CustomerProfileDtoEdgeModel.base"
import { CustomerProfileDtoModel, CustomerProfileDtoModelType } from "./CustomerProfileDtoModel"
import { CustomerProfileDtoModelSelector } from "./CustomerProfileDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  nodes: IObservableArray<CustomerProfileDtoModelType>;
}

/**
 * CustomerProfilePaginatedDtoBase
 * auto generated base class for the model CustomerProfilePaginatedDtoModel.
 */
export const CustomerProfilePaginatedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('CustomerProfilePaginatedDto')
  .props({
    __typename: types.optional(types.literal("CustomerProfilePaginatedDto"), "CustomerProfilePaginatedDto"),
    edges: types.union(types.undefined, types.null, types.array(types.late((): any => CustomerProfileDtoEdgeModel))),
    nodes: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => CustomerProfileDtoModel)))),
    totalCount: types.union(types.undefined, types.integer),
    hasNextPage: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class CustomerProfilePaginatedDtoModelSelector extends QueryBuilder {
  get totalCount() { return this.__attr(`totalCount`) }
  get hasNextPage() { return this.__attr(`hasNextPage`) }
  edges(builder: string | CustomerProfileDtoEdgeModelSelector | ((selector: CustomerProfileDtoEdgeModelSelector) => CustomerProfileDtoEdgeModelSelector) | undefined) { return this.__child(`edges`, CustomerProfileDtoEdgeModelSelector, builder) }
  nodes(builder: string | CustomerProfileDtoModelSelector | ((selector: CustomerProfileDtoModelSelector) => CustomerProfileDtoModelSelector) | undefined) { return this.__child(`nodes`, CustomerProfileDtoModelSelector, builder) }
}
export function selectFromCustomerProfilePaginatedDto() {
  return new CustomerProfilePaginatedDtoModelSelector()
}

export const customerProfilePaginatedDtoModelPrimitives = selectFromCustomerProfilePaginatedDto().totalCount.hasNextPage
